const StoreFactory = {
	_stores: {},
	_storePromises: {},

	/**
	 * @private
	 * @param {string} storeName
	 * @returns {Promise<Object>}
	 */
	_getStore: function (storeName) {
		if (this._stores[storeName]) {
			return Promise.resolve(this._stores[storeName]);
		}

		if (!this._storePromises[storeName]) {
			let importPromise;

			switch (storeName) {
				case 'mediathek':
					importPromise = import('./MediathekStore.js');
					break;
                case 'achievement':
                    importPromise = import('./AchievementStore.js');
                    break;
				case 'clashOfCams':
					importPromise = import('./ClashOfCamsStore.js');
					break;
				case 'liveReactions':
					importPromise = import('./LiveReactionsStore.js');
					break;
				case 'spinwheel':
					importPromise = import('./SpinwheelStore.js');
					break;
				case 'proSearchMeta':
					importPromise = import('./ProSearchMetaStore.js');
					break;
				case 'searchResult':
					importPromise = import('./SearchResultStore.js');
					break;
				case 'survey':
					importPromise = import('./SurveyStore.js');
					break;
				default:
					throw new Error(`Unknown store: ${storeName}`);
			}

			this._storePromises[storeName] = importPromise.then((module) => {
				this._stores[storeName] = module.default;
				return this._stores[storeName];
			});
		}

		return this._storePromises[storeName];
	},

	/**
	 * @returns {Promise<Object>}
	 */
	getMediathekStore: function () {
		return this._getStore('mediathek');
	},
	/**
	 * @returns {Promise<Object>}
	 */
	getAchievementStore: function () {
		return this._getStore('achievement');
	},

	/**
	 * @returns {Promise<Object>}
	 */
	getClashOfCamsStore: function () {
		return this._getStore('clashOfCams');
	},

	/**
	 * @returns {Promise<Object>}
	 */
	getLiveReactionsStore: function () {
		return this._getStore('liveReactions');
	},

	/**
	 * @returns {Promise<Object>}
	 */
	getSpinwheelStore: function () {
		return this._getStore('spinwheel');
	},

	/**
	 * @returns {Promise<Object>}
	 */
	getProSearchMetaStore: function () {
		return this._getStore('proSearchMeta');
	},

	/**
	 * @returns {Promise<Object>}
	 */
	getSearchResultStore: function () {
		return this._getStore('searchResult');
	},

	/**
	 * @returns {Promise<Object>}
	 */
	getSurveyStore: function () {
		return this._getStore('survey');
	},
};

export default StoreFactory;
